import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout';
import { PTwoLevelSelectComponent } from './p-two-level-select.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PActionButtonModule } from '@panaya/ui/p-action-button';
import { PipeModule } from '@panaya/ui/pipes';
import { PIconModule } from '@panaya/ui/p-icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
    declarations: [PTwoLevelSelectComponent],
    imports: [
        CommonModule,
        TranslateModule,
        ExtendedModule,
        MatFormFieldModule,
        MatMenuModule,
        PActionButtonModule,
        FormsModule,
        ReactiveFormsModule,
        PipeModule,
        PIconModule
    ],
    exports: [PTwoLevelSelectComponent]
})
export class PTwoLevelSelectModule {}
